export default __webpack_public_path__ + "static/media/AndriyM352.7344e645.jpg";